import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { PlatformValidationComponent } from './components/control-messages/app-platform-validation-control-messages.component';
import { ValidationService } from './services/validation.service';
import { PlatformComponentsModule } from '../app-platform-core-components';

// @dynamaic
@NgModule({
    imports: [
        TranslateModule.forChild(),
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: [
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'lt-sm',
                'lt-md',
                'lt-lg',
                'lt-xl',
                'gt-xs',
                'gt-sm',
                'gt- md',
                'gt-lg'
            ]
        }),
        MatProgressSpinnerModule,
        PlatformComponentsModule,
        MatSnackBarModule
    ],
    declarations: [PlatformValidationComponent],
    exports: [PlatformValidationComponent],
    providers: [ValidationService]
})
export class PlatformValidationModule {}
